import styled from "@emotion/styled";

export const LogoCustom = styled('img')(({theme, visible }) => ({
  verticalAlign: "sub",
  marginRight: theme.spacing(1),
  height:"40px",
  ...(visible && {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }),
}))
